import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import { useDialog } from "@platform/store";
import {
  MarketingAddYourInstitutionDialog,
  AddYourInstitutionFormData,
} from "./MarketingAddYourInstitutionDialog";
import { marketingEventBus } from "@platform/events/marketing.events";

/**
 * Container for MarketingAddYourInstitutionDialog.
 * Handles dialog state, API submission, and event tracking.
 */
export function MarketingAddYourInstitutionDialogContainer() {
  const { activeDialog, closeDialog } = useDialog();
  const isOpen = activeDialog === "addYourInstitution";

  const submitForm = useMutation({
    mutationFn: async (data: AddYourInstitutionFormData) => {
      marketingEventBus.emitEvent("addInstitution:submit", data);

      return await apiRequest(
        "/marketing/contact/",
        "POST",
        {
          first_name: data.firstName,
          last_name: data.lastName,
          ...data,
          form_type: "institution",
        },
        false
      );
    },
    onSuccess: (_data, variables) => {
      marketingEventBus.emitEvent("addInstitution:success", variables);
    },
  });

  const handleClose = () => {
    closeDialog();
  };

  return (
    <MarketingAddYourInstitutionDialog
      isOpen={isOpen}
      onClose={handleClose}
      onSubmit={submitForm.mutateAsync}
    />
  );
}

